import { useShallow } from "zustand/react/shallow";
import { useNotificationStore, NotificationState } from "../Stores/NotificationStore";
import { AlertColor } from "@mui/material";

export const useNotification = () => {
  const { addNotification, clearNotification } = useNotificationStore(
    useShallow((state) => ({
      addNotification: state.addNotification,
      clearNotification: state.clearNotification,
    })),
  );

  const displayNotification = (notification: NotificationState) => {
    addNotification(notification);
  };

  const displaySuccess = (message: string | JSX.Element) => {
    displayNotification({ message, type: "success" });
  };
  const displayWarning = (message: string | JSX.Element) => {
    displayNotification({ message, type: "warning" });
  };
  const displayError = (message: string | JSX.Element) => {
    displayNotification({ message, type: "error" });
  };
  const displayInfo = (message: string | JSX.Element) => {
    displayNotification({ message });
  };
  const displayUpload = (message: string | JSX.Element, timeout: number, type: AlertColor) => {
    displayNotification({ message, type, timeout, autoClose: timeout !== Infinity });
  };

  return {
    clearNotification,
    displayNotification,
    displayError,
    displaySuccess,
    displayWarning,
    displayInfo,
    displayUpload,
  } as const;
};
